<template>
  <div class="container exam">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item>题目管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">题目管理</h2>
        </div>
        <div class="right">
          <!--    <el-button
            class="button"
            type="primary"
            @click="handleToCategory"
          >分类管理</el-button> -->
          <!--      <el-button
            class="button"
            type="primary"
            @click="handleCreate"
          >创建题目</el-button> -->
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="题目"
                      prop="name">
          <el-input v-model="query.keywords"
                    placeholder="请输入"
                    style="width:300px;"
                    clearable></el-input>
        </el-form-item>
        <!--   <el-form-item
          label="题目"
          prop="name"
        >
          <el-input
            v-model="query.keyword"
            placeholder="输入关键字"
            @input="fetchExamList(true)"
            style="width:300px;"
            clearable
          ></el-input>
        </el-form-item> -->
        <el-form-item label="专业"
                      prop="name">
          <el-input v-model="query.paper_major_keyword"
                    placeholder="输入关键字"
                    @input="fetchExamList(true)"
                    style="width:300px;"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="题型"
                      prop="category_id">
          <el-select v-model="query.answer_type"
                     placeholder="请选择"
                     @change="fetchExamList(true)"
                     clearable>
            <el-option v-for="(item,index) in answer_type"
                       :key="index"
                       :label="item.name"
                       :value="item.type">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年份">
          <el-date-picker type="years"
                          v-model="query.paper_years"
                          placeholder="选择一个或多个年"
                          value-format="yyyy"
                          @input="fetchExamList(true)">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="试卷标题"
                      prop="name">
          <el-input v-model="query.paper_keyword"
                    placeholder="输入关键字"
                    @input="fetchExamList(true)"
                    style="width:300px;"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="题库名称"
                      prop="product_keyword">
          <el-input v-model="query.product_keyword"
                    placeholder="输入题库名称"
                    @input="fetchExamList()"></el-input>
        </el-form-item>
        <el-form-item label="关联章节"
                      prop="chapter_1_keyword">
          <el-input v-model="query.chapter_1_keyword"
                    placeholder="输入关联章节名称"
                    @input="fetchExamList()"></el-input>
        </el-form-item>
        <el-form-item label="关联题库院校/专业/科目"
                      prop="product_cms_keyword">
          <el-input v-model="query.product_cms_keyword"
                    placeholder="输入关联题库院校/专业/科目名称或代码"
                    @input="fetchExamList()"></el-input>
        </el-form-item>
        <!-- <div>

        </div> -->

      </el-form>
      <div class="divider"></div>
      <div class="action-wrap">
        <el-button type="primary"
                   @click="handleSearch">搜索</el-button>
      </div>
    </div>
    <div class="results card">
      <p class="title">题目列表</p>
      <div class="values">
        <el-table :data="results"
                  border>

          <el-table-column prop="id"
                           label="ID"
                           align="center"
                           width="80">
          </el-table-column>

          <el-table-column label="题目名称"
                           align="center"
                           width="750">
            <template slot-scope="scope">
              <div style="height:20px;text-align:left;"
                   v-html="scope.row.description"></div>
            </template>
          </el-table-column>
          <el-table-column prop="answer_type_text"
                           label="题目类型"
                           align="center">
          </el-table-column>

          <el-table-column label="引用试卷"
                           align="center"
                           width="320">
            <template slot-scope="scope">
              <el-collapse v-model="scope.row.activeName"
                           accordion>
                <el-collapse-item :title="scope.row.paper_list.length?`${scope.row.paper_list[0].major_codes?`（${scope.row.paper_list[0].major_codes}）`:''}${scope.row.paper_list[0].major_names?`${scope.row.paper_list[0].major_names}`:''}《${scope.row.paper_list[0].name}》第${scope.row.paper_list[0].sort+1}题`:'无'"
                                  name="1">
                  <div class="collapse-div"
                       v-for="(item,index) in scope.row.paper_list"
                       :key="index">
                    <span v-if="index!=0">
                      《{{item.name}}》第{{item.sort+1}}题
                    </span>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </template>
          </el-table-column>
          <el-table-column prop="product_name"
                           label="关联题库名称"
                           min-width="300"
                           align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.arr_chapter_info.map(item => item.product_name).join('、') }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="chapter_name_1"
                           label="关联章节名称"
                           min-width="300"
                           align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.arr_chapter_info.map(item => item.chapter_name_1).join('、') }}</span>
            </template>
          </el-table-column>
          <el-table-column label="做题人数"
                           align="center">
            <template slot-scope="scope">
              <div>{{scope.row.user_count}}人</div>
            </template>
          </el-table-column>
          <el-table-column label="做题次数"
                           align="center">
            <template slot-scope="scope">
              <div>{{scope.row.total_count}}次</div>
            </template>
          </el-table-column>
          <el-table-column label="正确率"
                           align="center">
            <template slot-scope="scope">
              <div>{{scope.row.right_rate*100}}%</div>
            </template>
          </el-table-column>

          <el-table-column label="更新时间"
                           align="center"
                           width="130">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY.MM.DD")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间"
                           align="center"
                           width="130">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY.MM.DD")
              }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            fixed="right"
            label="操作"
            width="120"
            align="center"
            v-if="isfixed"
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="handleEdit(scope.row)"
              >编辑</el-link> -->
          <!--        <el-link
                type="danger
            "
                @click="handleRemove(scope.row.id)"
                :underline="false"
              >删除</el-link> -->
          <!-- </template>
          </el-table-column> -->
          <!-- <el-table-column label=""
                           width="40"
                           align="center"
                           fixed="right"
                           v-else>
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a"
                                    style="margin-bottom:6px;"><span @click="handleEdit(scope.row)"
                          style="font-size:16px;color: #409EFF;">
                      编辑
                    </span></el-dropdown-item> -->
          <!--           <el-dropdown-item
                    command="d"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleRemove(scope.row.id)"
                      style="font-size:16px;color: #F56C6C;"
                    >
                      删除
                    </span></el-dropdown-item> -->
          <!-- </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ReadCard from '@/components/card/Read'
import { examPaperItemList, examPaperItemDestroy } from '@/api/exam'

export default {
  components: {
    ReadCard,
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      createDatetime: '',
      pageTotal: 10,
      filter: {
        status: [
          { label: '全部', value: '' },
          { label: '已发布', value: '1' },
          { label: '未发布', value: '0' },
        ],
        sorts: [
          { label: '最新', value: '1' },
          { label: '最热', value: '2' },
        ],
      },
      results: [],
      isfixed: document.body.clientWidth < 820 ? false : true,
      answer_type: [
        {
          name: '单选题',
          type: 0,
        },
        {
          name: '多选题',
          type: 1,
        },
        {
          name: '名词解释',
          type: 5,
        },
        {
          name: '简答题',
          type: 6,
        },
        {
          name: '论述题',
          type: 7,
        },
        {
          name: '判断题',
          type: 3,
        },
        {
          name: '问答题',
          type: 4,
        },
        {
          name: '材料题',
          type: 8,
        },
      ],
      value6: '',
    }
  },
  created() {
    this.parseQuery()
    this.fetchExamList()
    this.$store.dispatch('getExamCategoryList')
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.startTime = this.$moment(value[0]).valueOf()
        this.query.endTime = this.$moment(value[1]).valueOf()
      } else {
        this.query.startTime = ''
        this.query.endTime = ''
      }
    },
  },
  methods: {
    // 阅读列表请求
    fetchExamList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      const params = Object.assign({}, this.query)

      if (params.paper_years) {
        params.paper_years = params.paper_years.filter((v) => v).join(',')
      }
      if (params.keywords) {
        params.keywords = params.keywords.split(' ').join(',')
      }
      examPaperItemList(params).then((res) => {
        this.results = res.list || []
        this.results.forEach((item) => {
          this.$set(item, 'activeName', '')
        })
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 检索条件变化
    handleFilterChange(value, type) {
      if (type === 'sort') {
        this.query.sort = value
      }
    },
    // 触发搜索按钮
    handleSearch() {
      console.log(this.query.keywords)
      this.$set(this.query, 'pageIndex', 1)
      this.fetchExamList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchExamList()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchExamList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchExamList()
    },
    handleRemove(examId) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          examPaperItemDestroy({ id: examId }).then((res) => {
            this.$message.success(`删除成功`)
            this.fetchExamList()
          })
        })
        .catch(() => {})
    },
    // 阅读资料创建
    handleEdit(row) {
      this.$router.push(`/examQuestions/edit?id=${row.id}`)
    },
    handleCreate() {
      this.$router.push(`/examQuestions/create`)
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
      if (this.query.paper_years) {
        this.query.paper_years = this.query.paper_years.split(',')
      }
      if (this.query.startTime && this.query.endTime) {
        this.createDatetime = [
          this.$moment(Number(this.query.startTime)),
          this.$moment(Number(this.query.endTime)),
        ]
      }
    },
    // 同步URL请求参数
    syncQuery() {
      const params = Object.assign({}, this.query)
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      )
      if (params.paper_years) {
        params.paper_years = params.paper_years.filter((v) => v).join(',')
      }
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        })
    },
    pickerChange(e) {
      console.log(e)
    },
  },
}
</script>

<style scoped lang="less">
.exam {
  // div {
  //   white-space: nowrap;
  //   text-overflow: ellipsis;
  //   overflow: hidden;
  // }
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }
  // .filters {
  //   margin-top: 10px;

  //   .search-wrap {
  //     margin-bottom: -18px;

  //     .datetime {
  //       width: 380px;
  //     }
  //   }
  //   .divider {
  //     border-bottom: 1px dashed #dcdfe6;
  //     margin: 15px 0;
  //   }
  //   .action-wrap {
  //     display: flex;
  //     justify-content: flex-end;
  //   }
  // }
  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }

      /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
        box-shadow: none !important;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .search-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }

    .filter-item {
      display: flex;

      .label {
        line-height: 32px;
        margin-right: 10px;
      }
      .values {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
      }
      .value-item {
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
        padding: 0 10px;
        margin-right: 5px;
        cursor: pointer;

        &.active {
          color: #fff;
          background: #409eff;
        }
      }
    }
  }
  .results {
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
    }
    .exam-item {
      margin-right: 15px;
      margin-bottom: 15px;
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}
.item-table-column {
  text-align: left;
}
.el-collapse-item {
  background: transparent;
}
.el-collapse {
  border: none;
}
.collapse-div {
  text-align: left;
}
/deep/.el-collapse-item__header {
  font-weight: 500;
  color: #606266;
  height: auto;
  line-height: normal;
}
</style>
